import axios from 'axios';
const lsToken = JSON.parse(localStorage.getItem("token"));
export default {
    state: {
        notif: {
            simfoni: 0,
            harmoni: 0,
            kanala: 0,
            commDash: 0,
            cuenta: 0
        }
    },
    getters: {
        Get_Simfoni(state) {
            return state.notif.simfoni
        },
        Get_Harmoni(state) {
            return state.notif.harmoni
        },
        Get_Kanala(state) {
            return state.notif.kanala
        },
        Get_CommDash(state) {
            return state.notif.commDash
        },
        Get_Cuenta(state) {
            return state.notif.cuenta
        },
    },
    mutations: {
        CountSimfoni(state, payload) {
            let notifCount = 0;
            for (let i = 0; i < payload.length; i++) {
                if (payload[i] == undefined) {
                    notifCount = notifCount + 0
                } else {
                    notifCount = notifCount + payload[i].data.data.length
                }
            }
            state.notif.simfoni = notifCount
        },
        CountHarmoni(state, payload) {
            let notifCount = 0;
            for (let i = 0; i < payload.length; i++) {
                if (payload[i] == undefined) {
                    notifCount = notifCount + 0
                } else {
                    notifCount = notifCount + payload[i].data.data.length
                }
            }
            state.notif.harmoni = notifCount
        },
        CountKanala(state, payload) {
            let notifCount = 0;
            for (let i = 0; i < payload.length; i++) {
                if (payload[i] == undefined) {
                    notifCount = notifCount + 0
                } else {
                    notifCount = notifCount + payload[i].data.data.length
                }
            }
            state.notif.kanala = notifCount
        },
        CountDashboard(state, payload) {
            state.notif.commDash = payload
        },
        CountCuenta(state, payload) {
            state.notif.cuenta = payload
        },
    },
    actions: {
        async FetchSimfoniNotif(store) {
            const aksi = axios({
                method: "get",
                url: process.env.VUE_APP_SIMFONI + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                    aksi: 2
                },
                auth: {
                    username: store.rootState.user.activeUser.data.tlc,
                    password: store.rootState.user.activeUser.data.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.activeUser.key || lsToken.key,
                }
            }).catch(err => {
                console.log(err.response)
            });

            const informasi = axios({
                method: "get",
                url: process.env.VUE_APP_SIMFONI + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                    aksi: 1
                },
                auth: {
                    username: store.rootState.user.activeUser.data.tlc,
                    password: store.rootState.user.activeUser.data.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.activeUser.key || lsToken.key
                }
            }).catch(err => {
                console.log(err.response)
            });

            await axios.all([aksi, informasi]).then(response => {
                store.commit('CountSimfoni', response)
            });
        },
        async FetchHarmoniNotif(store) {
            const aksi = axios({
                method: "get",
                url: process.env.VUE_APP_HARMONI + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                    aksi: 2
                },
                auth: {
                    username: store.rootState.user.activeUser.data.tlc,
                    password: store.rootState.user.activeUser.data.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.activeUser.key || lsToken.key,
                }
            }).catch(err => {
                console.log(err)
            });

            const informasi = axios({
                method: "get",
                url: process.env.VUE_APP_HARMONI + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                    aksi: 1
                },
                auth: {
                    username: store.rootState.user.activeUser.data.tlc,
                    password: store.rootState.user.activeUser.data.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.activeUser.key || lsToken.key
                }
            }).catch(err => {
                console.log(err)
            });

            await axios.all([aksi, informasi]).then(response => {
                store.commit('CountHarmoni', response)
            });
        },
        async FetchKanalaNotif(store) {
            const aksi = axios({
                method: "get",
                url: process.env.VUE_APP_KANALA + "api/notifikasi",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                    aksi: 2
                },
                auth: {
                    username: store.rootState.user.activeUser.data.tlc,
                    password: store.rootState.user.activeUser.data.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.activeUser.key || lsToken.key,
                }
            }).catch(err => {
                console.log(err)
            });
    
            const informasi = axios({
                method: "get",
                url: process.env.VUE_APP_KANALA + "api/notifikasi",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                    aksi: 1
                },
                auth: {
                    username: store.rootState.user.activeUser.data.tlc,
                    password: store.rootState.user.activeUser.data.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.user.activeUser.key || lsToken.key
                }
            }).catch(err => {
                console.log(err)
            });
    
            await axios.all([aksi, informasi]).then(response => {
                store.commit('CountKanala', response)
            });
        },
        async FetchCommDashNotif(store) {
            const aksi = axios({
                method: "get",
                url: (process.env.VUE_APP_EIS).replaceAll('api/v1/','') + "api/chatHistory",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                },
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
            }).catch(err => {
                console.log(err)
            });

            await axios.all([aksi]).then(response => {
                store.commit('CountDashboard', response[0].data.data)
            });
        },
        async FetchCuentaNotif(store) {
            const aksi = axios({
                method: "get",
                url: process.env.VUE_APP_ACCOUNTING + "api/notification",
                params: {
                    tlc: store.rootState.user.activeUser.data.tlc,
                },
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
            }).catch(err => {
                console.log(err)
            });

            await axios.all([aksi]).then(response => {
                store.commit('CountCuenta', response[0].data.data.data)
            });
        }
    },
}